// extracted by mini-css-extract-plugin
export default {"wrapper":"JI3vdr9lGDhP3giZtBKE"};